/** @jsx jsx */
import { jsx } from "frontend/src/utils/jsx"
import Img from "gatsby-image"
import { SectionGrid } from "frontend/src/components/Layout"
import { getFluidHeightFromAsset } from "frontend/src/utils/gatsbyImageHelpers"

function AccentColorImageText({ title, subTitle, image, color }) {
  return (
    <SectionGrid sx={{ pt: 8 }}>
      <SectionGrid.wide
        sx={{
          my: 7,
          mx: [0, 6, 6],
          color: "white",
          display: "grid",
          gridTemplateColumns: ["1fr", "1fr", "2fr 1fr 500px"],
        }}
      >
        <Img
          sx={{
            gridColumn: ["1 / span 1", "1 / span 1", "1 / span 3"],
            gridRow: "1 / span 1",
          }}
          fluid={getFluidHeightFromAsset(image, 1300)}
        />
        <div
          sx={{
            textShadow: "0 0 20px black",
            gridColumn: "1 / span 1",
            gridRow: "1 / span 1",
            zIndex: "1",
            pl: 11,
            pt: 12,
            display: ["none", "none", "block"],
            mb: 5,
          }}
        >
          <p
            sx={{
              textAlign: "left",
              fontFamily: "heading",
              fontSize: ["28px", "28px", "38px"],
              lineHeight: ["30px", "30px", "44px"],
              letterSpacing: "-1.24px",
              fontWeight: ["medium", "medium", "regular"],
            }}
          >
            {title[0]}
            <br />
            {title[1]}
          </p>
        </div>

        <div
          sx={{
            textShadow: "0 0 20px black",
            gridColumn: "3 / span 1",
            gridRow: "1 / span 1",
            zIndex: "1",
            alignSelf: "flex-end",
            pr: 11,
            pb: 12,
            display: ["none", "none", "block"],
          }}
        >
          <p
            sx={{
              fontFamily: "heading",
              fontSize: ["28px", "28px", "38px"],
              lineHeight: ["30px", "30px", "44px"],
              letterSpacing: "-1.24px",
              fontWeight: ["medium", "medium", "regular"],
              textAlign: "right",
              mb: 5,
            }}
          >
            {title[2]}
            <br />
            <span sx={{ color: color.selected }}>{title[3]}</span>
          </p>

          <p
            sx={{
              fontSize: "22px",
              fontFamily: "heading",
              fontWeight: "light",
              lineHeight: "28px",
              letterSpacing: "0px",
              textAlign: "right",
            }}
          >
            {subTitle}
          </p>
        </div>
        <div
          sx={{
            display: ["grid", "grid", "none"],
            gridRow: "1 / span 1",
            gridColumn: "1 / span 1",
            zIndex: "1",
            pt: "300px",
            px: 8,
            mb: 10,
          }}
        >
          <p
            sx={{
              fontFamily: "heading",
              fontSize: ["28px", "28px", "38px"],
              lineHeight: ["30px", "30px", "44px"],
              letterSpacing: "-1.24px",
              fontWeight: ["medium", "medium", "regular"],
              mb: 5,
            }}
          >
            {title[0] + " "}
            {title[1] + " "}
            {title[2] + " "}
            <br />
            <span sx={{ color: color.selected }}>{title[3]}</span>
          </p>
          <p
            sx={{
              fontSize: "22px",
              fontFamily: "heading",
              fontWeight: "light",
              lineHeight: "28px",
              letterSpacing: "0px",
              mb: 11,
            }}
          >
            {subTitle}
          </p>
        </div>
      </SectionGrid.wide>
    </SectionGrid>
  )
}

export { AccentColorImageText }
